module.exports = __webpack_public_path__ + "static/media/projectsImage8.e3152e7b.jpg";